import React from 'react'
import { InlineMessage, INLINE_MESSAGE_VARIANTS } from 'transfix-ui/components/InlineMessage'

export enum MARKETPLACE_TYPE {
  marketplace = 'marketplace',
  loadBoard = 'loadBoard',
}

interface IReasonsProps {
  reasons: string[]
}

interface IMarketplaceEligibilityProps {
  type: MARKETPLACE_TYPE
  baseReasons: string[]
  specificReasons: string[]
}

export const Reasons = React.memo<IReasonsProps>(({ reasons }) => (
  <ul>
    {reasons.map(reason => (
      <li className='pa0' key={reason}>
        {reason}
      </li>
    ))}
  </ul>
))

export const MarketplaceEligibility = React.memo<IMarketplaceEligibilityProps>(
  ({ baseReasons, specificReasons, type }) => {
    const combinedReasons = [...baseReasons, ...specificReasons]
    const notEligible = combinedReasons.length > 0

    let header = notEligible ? 'Not eligible for DAT posting.' : 'Eligible for DAT posting'
    if (type === MARKETPLACE_TYPE.marketplace) {
      header = notEligible
        ? 'Not eligible for listing on the Transfix App.'
        : 'Eligible for listing on the Transfix App'
    }

    const eligibleMessage =
      type === MARKETPLACE_TYPE.marketplace
        ? 'This shipment can be listed on the mobile app and web app.'
        : 'This shipment can be posted to DAT.'

    const inlineType = notEligible ? INLINE_MESSAGE_VARIANTS.WARNING : INLINE_MESSAGE_VARIANTS.INFO
    return (
      <div className='row mv2'>
        <InlineMessage
          message={
            <div>
              <strong>{header}</strong>
              <div>
                {notEligible ? (
                  <Reasons reasons={combinedReasons} />
                ) : (
                  <span>{eligibleMessage}</span>
                )}
              </div>
            </div>
          }
          type={inlineType}
        />
      </div>
    )
  }
)
